// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"9751ca1f","626":"62126e0c"}[chunkId] + ".chunk.css";
};